import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

type Props = {
  name: any;
  label: any;
  control?: any;
  color?: any;
  defaultValue?: any;
  onChange?: any;
};
const UCheckbox = ({ name, label, control, color, defaultValue, onChange }: Props, ref: any) => {
  const formContext = useFormContext();
  const _control = control || formContext.control;
  const { field } = useController({ name, control: _control, defaultValue });
  return (
    <FormControlLabel
      control={
        <Checkbox
          onChange={(evt) => {
            if (onChange) onChange(evt);
            field.onChange(evt);
          }}
          onBlur={field.onBlur}
          name={field.name}
          checked={field.value}
          color={color}
          inputRef={(r) => {
            field.ref(r);
            if (ref) {
              if (typeof ref == 'function') ref(r);
              else ref.current = r;
            }
          }}
        />
      }
      label={label}
    />
  );
};

export default React.forwardRef(UCheckbox);
